export const macos = {
  id: 'macos',
  label: 'macOS',
  emoji: '🖥',
  colorScheme: 'purple',
  description: 'Mac App Store & desktop',
  folder: 'macos/AppIcon.appiconset',
  icons: [
    { filename: 'AppIcon-16.png',      size: 16,   pointSize: 16,  scale: 1, idiom: 'mac', label: '16pt @1x' },
    { filename: 'AppIcon-16@2x.png',   size: 32,   pointSize: 16,  scale: 2, idiom: 'mac', label: '16pt @2x' },
    { filename: 'AppIcon-32.png',      size: 32,   pointSize: 32,  scale: 1, idiom: 'mac', label: '32pt @1x' },
    { filename: 'AppIcon-32@2x.png',   size: 64,   pointSize: 32,  scale: 2, idiom: 'mac', label: '32pt @2x' },
    { filename: 'AppIcon-128.png',     size: 128,  pointSize: 128, scale: 1, idiom: 'mac', label: '128pt @1x' },
    { filename: 'AppIcon-128@2x.png',  size: 256,  pointSize: 128, scale: 2, idiom: 'mac', label: '128pt @2x' },
    { filename: 'AppIcon-256.png',     size: 256,  pointSize: 256, scale: 1, idiom: 'mac', label: '256pt @1x' },
    { filename: 'AppIcon-256@2x.png',  size: 512,  pointSize: 256, scale: 2, idiom: 'mac', label: '256pt @2x' },
    { filename: 'AppIcon-512.png',     size: 512,  pointSize: 512, scale: 1, idiom: 'mac', label: '512pt @1x' },
    { filename: 'AppIcon-512@2x.png',  size: 1024, pointSize: 512, scale: 2, idiom: 'mac', label: '512pt @2x' },
  ],
  generateContentsJson(appName = 'AppIcon') {
    return {
      images: this.icons.map((icon) => ({
        filename: icon.filename,
        idiom: icon.idiom,
        scale: `${icon.scale}x`,
        size: `${icon.pointSize}x${icon.pointSize}`,
      })),
      info: { version: 1, author: 'xcode' },
    };
  },
};
